import React, { ReactNode } from 'react';
import AntdModal from 'antd/lib/modal';

/**
 * {@docCategory ErrorModal}
 */
export interface ErrorModalProps {
   /**
    * The title to display.
    */
   title: ReactNode;

   /**
    * The content.
    */
   content: ReactNode;

   /**
    * Used to customize the OK button text.
    * @defaultvalue OK
    */
   okText?: ReactNode;

   /**
    * Callback called when the user presses the OK button, presses enter, or hits escape to
    * dismiss the modal.
    */
   onOk?: () => void;
}

export class ErrorModal {
   static show(props: ErrorModalProps) {
      AntdModal.error({
                         title: props.title,
                         content: props.content,
                         okText: props.okText,
                         onOk: props.onOk,
                         onCancel: props.onOk
                      });
   }
}
